export default __webpack_public_path__ + "static/media/Batsman.1172ee05.png";